<template lang="html">
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 16 15" fill="none">
    <rect x="4.5" y="0.75" width="6.5" height="3.5" stroke="black" stroke-width="1.5"/>
    <rect x="4.5" y="7.99316" width="6.5" height="5.5" stroke="black" stroke-width="1.5"/>
    <path d="M11.75 11.2432H14.75V4.24316L0.75 4.24316L0.75 11.2432H3.75" stroke="black" stroke-width="1.5"/>
  </svg>
</template>

<style lang="css" scoped>
</style>

<script>
export default {
  name: 'IconPrint'
}
</script>
